'use strict';

const breakpoints = require('../breakpoints');

module.exports = function (scrollToElement, includeHeaderHeight = true) {
    const shouldIncludeHeaderHeight = breakpoints.down('md') ? false : includeHeaderHeight;
    const scrollOffset = (scrollToElement?.getBoundingClientRect()?.top || 0) + (window.scrollY || 0);
    const headerHeight = document.querySelector('.js-header')?.getBoundingClientRect().height || 0;
    const top = shouldIncludeHeaderHeight ? (scrollOffset - headerHeight) : scrollOffset;

    window.scrollTo({
        top: top
    });
};
